import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SliderContentUpdate } from '../../services';

export const fetchSliderContentUpdate = createAsyncThunk(
    'sliderContentUpdate/fetchSliderContentUpdate',
    async ({ id, filesToKeep, file, title, slug, sliderId, sort }) => {
        const response = await SliderContentUpdate(id, file, title, slug, sliderId, sort, filesToKeep)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const sliderContentUpdateSlice = createSlice({
    name: 'sliderContentUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentUpdateSlice.reducer;
